// extracted by mini-css-extract-plugin
export default {"collapsableSection":"XTOv0T6pFHRBJgyYejQs"};